<script setup>
import {onMounted} from 'vue';
import fileService from '@/services/FileService';

const props = defineProps({
  isButton: {
    type: Boolean,
    default: false,
  },
  uuid: {
    type: String,
    required: true,
  },
  downloadUrl: {
    type: String,
    required: false,
  }
});

onMounted(() => {

});

async function downloadFile() {
  fileService.getContent(props.uuid).then(response => {
    fileService.downloadFileByPlatform(response.content, response.filename, response.extension);
  });
}
</script>

<template>
  <button v-if="isButton" class="btn btn-primary" @click="downloadFile">{{ t('downloadButtonComponent.download') }}</button>
  <button v-else class="btn btn-link" @click="downloadFile"><i class="mdi mdi-download mdi-18px"></i></button>

</template>
